import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { EventsService } from 'src/app/services/event/event.service';
import { GeoResponse } from 'src/app/interfaces/geo-interface';
import { JurisdictionService } from 'src/app/services/geo/jurisdiction.service';
import { StructureService } from 'src/app/services/structure/structure.service';
import { GeoLocationStrategyService } from 'src/app/services/geo-location-strategy/geo-location-strategy.service';
import { GeoLocationControllerService } from 'src/app/services/geo-location/geo-location-controller.service';

@Component({
    selector: 'app-signup-result',
    templateUrl: './signup-result.component.html',
    styleUrls: ['./signup-result.component.scss'],
})
export class SignupResultComponent implements OnInit {


    public wasSuccessful: boolean = true;
    public responsibleGamingNumber: string;
    public startupBoydRewardEnrollPopupEnabled: number;
    afterSuccessfulRegistration: boolean;

    constructor(
        private config: ConfigService,
        private eventsService: EventsService,
        private jurisdiction: JurisdictionService,
        private navigator: Navigator,
        private structure: StructureService,
        private geoLocationControllerService: GeoLocationControllerService,
        private geoLocationStrategyService: GeoLocationStrategyService,
        private userSessionService: UserSessionService,
    ) { }

    ngOnInit(): void {
        this.responsibleGamingNumber = this.config.getConfig().RESPONSIBLE_GAMING_NUMBER ?? '1-800-522-4700';
        this.eventsService.publish('event:lobby:show');

        setTimeout(() => this.structure?.buildLobby(), 750);
    }

    ionViewCanLeave() {
        localStorage.setItem('MFA.signup', 'false');
        this.eventsService.publish('event:signupResult:flag');
    }

    closeSuccessModal = () => {
        setTimeout(() => {
            this.activateCustomer();
        }, 500);
    }

    protected openPage(page) {
        return this.navigator.navigateTo(page, { multipleModals: true }, { previousPage: "SignupResult" });
    }

    protected redirectUserToLobby(): void {
        this.navigator.dismissAll();
        //this.appActions.redirectAfterSuccessfulRegistration();
        this.eventsService.publish("event:login", {
            customer_id: this.userSessionService.getCustomerId(),
        });
        //todo replace this everywhere with routing default route this.eventsService.publish('action:changeTab', 'casino');
    }

    private activateCustomer = () => {
        localStorage.setItem('MFA.signup', 'false');
        this.userSessionService.refreshCustomer().subscribe((customer: CustomerModel) => {

            this.userSessionService.setUserStatus({
                customerId: this.userSessionService.getCustomerId(),
                sessionToken: this.userSessionService.getSessionToken()
            })
        });


        const config = this.config.getConfig();
        const geoAfterLoginFlag: boolean = this.config.isFeatureON(config, 'FEATURE_GEOLOCATION_ENFORCED_ON_LOGIN', false);

        if (geoAfterLoginFlag) {
            this.addGeo();
        }


        this.redirectUserToLobby();

        this.eventsService.publish("event:notifications:start");
    }

    private addGeo = () => {
        if (this.geoLocationStrategyService.isGeoOptimizationEnabled()) {
            this.geoLocationControllerService.executeGeoLocationProcess()
                .then((geoResp: GeoResponse) => {
                    if (geoResp.is_allowed) {
                        console.log('Signup Result geo check passed');
                    } else {
                        console.log('Signup Result geo check failed');
                    }
                }).catch((err) => {
                    console.log("Signup Result: launch aborted.", err);
                });
        } else {
        this.jurisdiction
            .verifyJurisdiction(() => { })
            .then((geoResp: GeoResponse) => {
                console.log('Signup Result geo check');
            })
            .catch((err) => {
                console.log("Signup Result: launch aborted.", err);
            });
        }
    }

}
